import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import ProductSkuCSP from "../../../models/csp/ProductSkuCSP";
import productSkuService from "../../../services/csp/productSkuService";
import { RootState } from "../../index";

const namespaced = true;

interface ProductSkuState {
  productSkus: ProductSkuCSP[];
}

const state: ProductSkuState = {
  productSkus: []
};

const getters: GetterTree<ProductSkuState, RootState> = {
  getProductSkusCSP(state): ProductSkuCSP[] {
    return state.productSkus;
  }
};

const mutations: MutationTree<ProductSkuState> = {
  setProductSkus(state, productSkus: ProductSkuCSP[]) {
    state.productSkus = productSkus;
  }
};

const actions: ActionTree<ProductSkuState, RootState> = {
  async loadProductSkusCSP({ commit }, customerId: string) {
    const productSkus: ProductSkuCSP[] =
      await productSkuService.methods.getProductSkusCSP(customerId);
    commit("setProductSkus", productSkus);
  }
};

export const productSkuModuleCSP: Module<ProductSkuState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
